import { Routes } from '@angular/router';
import { LoginComponent } from './app-default-pages/login/login.component';
import { Error403Component } from './app-default-pages/error/error403/error403.component';
import { Error404Component } from './app-default-pages/error/error404/error404.component';
import { NpAuthChildGuard, NpPermission } from '@newpla/common';

export const routes: Routes = [
    { path: '', redirectTo: 'app', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'error/403', component: Error403Component },
    { path: 'error/404', component: Error404Component },
    {
        path: 'app', loadChildren: () => import('./app-main/app-main.module').then(m => m.AppMainModule),
        data: { permission: new NpPermission(true, [], []) }, canActivateChild: [NpAuthChildGuard]
    },
];
